import { Api } from '@community_dev/types'
import { CamelCasedPropertiesDeep } from 'type-fest'

import { ENDPOINTS } from 'constants/endpoints'
import { request } from 'utils/request'
import { route } from 'utils/router'

export type SSOConfig = CamelCasedPropertiesDeep<Api.SSOConfig>

export type SSOConfigResponse = CamelCasedPropertiesDeep<Api.SSOConfigResponse>
export type SSOConfigsResponse = CamelCasedPropertiesDeep<Api.SSOConfigsResponse>

export const getSSOConfig = (id: string): Promise<SSOConfigResponse> => {
  return request(route(ENDPOINTS.SSO.CONFIG, { id }))
}

export type UpsertSSOConfigInput = {
  id: string
  entityId: string
  signinUrl: string
  certificate: string
  ssoDomains: Array<{ domain: string }>
  metadataUrl?: string
}

export type CreateSSOConfigInput = Omit<UpsertSSOConfigInput, 'id'>

export const postSSOConfig = ({
  entityId,
  signinUrl,
  certificate,
  ssoDomains,
  metadataUrl,
}: CreateSSOConfigInput): Promise<SSOConfigResponse> => {
  return request(ENDPOINTS.SSO.CONFIGS, {
    method: 'POST',
    body: {
      entityId,
      signinUrl,
      certificate,
      ssoDomains,
      metadataUrl,
    },
  })
}

export const putSSOConfig = ({
  id,
  entityId,
  signinUrl,
  certificate,
  ssoDomains,
  metadataUrl,
}: UpsertSSOConfigInput): Promise<SSOConfigResponse> => {
  return request(route(ENDPOINTS.SSO.CONFIG, { id }), {
    method: 'PUT',
    body: {
      entityId,
      signinUrl,
      certificate,
      ssoDomains,
      metadataUrl,
    },
  })
}

export const deleteSSOConfig = (id: string): Promise<void> => {
  return request(route(ENDPOINTS.SSO.CONFIG, { id }), { method: 'DELETE' })
}

export const getSSOConfigs = (): Promise<SSOConfigsResponse> => {
  return request(ENDPOINTS.SSO.CONFIGS)
}
